import { UploadOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal, Space, Upload } from 'antd';
import React, { useEffect, useState } from 'react';
import { useBrands } from './BrandStore';
import MediaManager from '../../Media/MediaManager';
import { useForm } from 'antd/es/form/Form';

function Add(props) {
    let [previewVisible, setPreviewVisible] = useState(false)
    let [logo, setLogo] = useState(null)
    let { createBrand } = useBrands()
    let [form] = useForm();
    let handleSelect = (e) => {
        setLogo(e)
    }

    useEffect(() => {
        form.setFieldsValue({
            logo: logo
        })
    }, [logo])

    return (
        <>
            <Modal width={"80%"} open={previewVisible} footer={null} onCancel={() => setPreviewVisible(false)}>
                <MediaManager onSelect={handleSelect} />
            </Modal>
            <Form form={form} layout="vertical" onFinish={createBrand} encType="multipart/form-data">
                <Form.Item label="O'zbekcha nomi" name="nameuz" rules={[{ required: true, message: 'Please input your name!' }]}>
                    <Input />
                </Form.Item>
                <Form.Item label="Ruscha nomi" name="nameru" rules={[{ required: true, message: 'Please input your description!' }]}>
                    <Input />
                </Form.Item>
                <Form.Item label="Logo" name="logo">
                    <Input  readOnly defaultValue={logo} suffix={<Button type="primary" onClick={() => setPreviewVisible(true)}>Fayl yuklash</Button>} />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">Qo'shish</Button>
                </Form.Item>
            </Form>
        </>
    );
}

export default Add;